import { render } from "./PerfilDash.vue?vue&type=template&id=5969ec2b&scoped=true"
import script from "./PerfilDash.vue?vue&type=script&lang=js"
export * from "./PerfilDash.vue?vue&type=script&lang=js"

import "./PerfilDash.vue?vue&type=style&index=0&id=5969ec2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5969ec2b"]])

export default __exports__